var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-col",
    [
      _vm.pickerMode
        ? _c(
            "v-btn",
            { attrs: { icon: "", dark: "" } },
            [
              _c("v-icon", [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.isChosen
                        ? "mdi-checkbox-marked-outline"
                        : "mdi-checkbox-unmarked-outline"
                    ) +
                    " "
                ),
              ]),
            ],
            1
          )
        : !_vm.hideDelete
        ? _c(
            "v-btn",
            {
              attrs: { icon: "", dark: "" },
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                  $event.preventDefault()
                  return _vm.$emit("remove-file", _vm.file.id)
                },
              },
            },
            [_c("v-icon", [_vm._v("mdi-close-circle-outline")])],
            1
          )
        : _vm._e(),
      _c(
        "video",
        {
          staticStyle: { width: "100%", "border-radius": "10px" },
          attrs: { controls: "" },
        },
        [
          _c("source", {
            attrs: { src: _vm.file.url, type: `audio/${_vm.file.format}` },
          }),
        ]
      ),
      _vm._t("body"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }